import React from 'react';
import { jumpTo } from '@/navigate'
import Tips from "../../components/tips";
import BgAudio from "./bgAudio";
import './index.scss';

class App extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            time: 5,
            jumpFlag: false
        }
        this.timmer = ""
    }

    componentDidMount() {
        this.countTime()
    }
    countTime() {
        clearInterval(this.timmer);
        this.timmer = setInterval(() => {
            let time = this.state.time
            time--;
            this.setState({
                time
            })
            if (time == 0) {
                this.setState({
                    jumpFlag: true
                })
                clearInterval(this.timmer)
            }
        }, 1000);
    }
    finish() {
        if (!this.state.jumpFlag) {
            return false;
        }
        jumpTo("guide7")
    }
    render() {
        return (
            <div className="page page-guide guide_room_2">
                <div className="form_view">
                    <div className="count_time">
                        <div className="icon_time"><img src={require("../../assets/images/icon_time.png")} /></div>
                        <div>针灸治疗中…（{this.state.time}s）</div>
                    </div>
                    <div className="form_btn txt_c" >
                        <button className={this.state.jumpFlag ? "" : "disabled"} onClick={() => {this.finish()}}>确定</button>
                    </div>
                </div>
                <audio src={require("../../assets/audio/step_6.mp3")} autoPlay={true}/>
                {/* <Tips init={false} /> */}
                <BgAudio/>
            </div>
        );
    }
}

export default App;
